import { createContext, useContext, useState } from "react";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchData, setSearchData] = useState(null);

  const handleSearch = (data) => {
    setSearchData(data);
  };

  const clearSearch = () => {
    setSearchData(null);
  };

  return (
    <SearchContext.Provider value={{ searchData, handleSearch, clearSearch }}>
      {children}
    </SearchContext.Provider>
  );
};

//Custom Hook
export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearch must be used within SearchProvider");
  }
  return context;
};
